import {RoomBaseApiService} from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class ExamService extends RoomBaseApiService {
	async getExamInfo() {
		try {
			const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/info`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async getExamDetail(params) {
		try {
			const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/exam/detail`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async startExam(params) {
		try {
			const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/exams/${params.bankExamId}/exam`, params);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async endExam(params) {
		try {
			const response = await this.request().patch(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/exam`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async createUserExam(params) {
		try {
			const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users`, params);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async getUserSubmitStatus(params) {
		try {
			const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users/${params.userId}/user`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async submitUserAnswers(params) {
		try {
			const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users/${params.userId}/answers`, params);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async completeUserExam(params) {
		try {
			const response = await this.request().patch(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users/${params.userId}/user`, params);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async getAllUserAnswers(params) {
		try {
			const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users/infoAll`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}

	async getUserAnswers(params) {
		try {
			const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/users/${params.userId}/info`);
			return new ResponseWrapper(response, response.data.data);
		} catch (error) {
			throw new ErrorWrapper(error);
		}
	}
}

export const roomExamService = new ExamService()